import {Brick, registerBrick} from 'olympe';
import MSGraphPlanner from './DM_MSGraphPlanner';

export default class CodedCreatePlannerPayload extends Brick {

  /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {*} plannerObj
   * @param {function()} forwardEvent
   * @param {function(*)} setOutput
   */
  update ($, [plannerObj], [forwardEvent, setOutput]) {
    const plannerTitle = plannerObj.getTitle();
    const containerId = plannerObj.getContainerId();

    const plannerPlan = {
      container: {
        "@odata.type": "microsoft.graph.plannerPlanContainer",
        type: "group",
        containerId
      },
      title: plannerTitle
    };

    setOutput(plannerPlan);
    forwardEvent();
  }
}

registerBrick('018d4017c66825e0c581', CodedCreatePlannerPayload);
